// Paleta da marca MINEHR — fonte única de cores do sistema.
// O tailwind.config.js consome estes valores para gerar as classes utilitárias,
// e os gráficos (Recharts) importam os mesmos hex diretamente.
const colors = {
  primary: "#5C3F5C",
  primaryDark: "#4A3247",
  primarySoft: "#F4EFF4",
  primaryFaint: "#FAF7FA",
  accent: "#60BB9B",
  accentDark: "#2A9E72",
  accentSoft: "#E6F7EF",
  secondary: "#B79FB7",
  surface: "#F8FAFC",
  borderSubtle: "#E2E8F0",
  borderSoft: "#EDE7ED",
  // Tons escuros da IDV do site (hero/plum), usados em áreas de destaque.
  plumDeep: "#231A23",
  plumNight: "#1E1F24",
  plum: "#4A324A",
  lilac: "#735473",
  lilacSoft: "#D7C9D7",
  cream: "#F0D9A8",
};

// Interpola linearmente entre duas cores hex ("#RRGGBB") com t em [0, 1].
function mixHex(from, to, t) {
  const a = parseInt(from.slice(1), 16);
  const b = parseInt(to.slice(1), 16);
  const channel = (shift) => {
    const ca = (a >> shift) & 0xff;
    const cb = (b >> shift) & 0xff;
    return Math.round(ca + (cb - ca) * t);
  };
  const value = (channel(16) << 16) | (channel(8) << 8) | channel(0);
  return `#${value.toString(16).padStart(6, "0").toUpperCase()}`;
}

module.exports = { colors, mixHex };
